import React, { useState } from 'react';
import axios from 'cccisd-axios';
import Table from 'cccisd-table';
import IconUp from 'cccisd-icons/thumbs-up2';
import IconUpFill from 'cccisd-icons/thumbs-up3';
import IconDown from 'cccisd-icons/thumbs-down2';
import IconDownFill from 'cccisd-icons/thumbs-down3';

const Boilerplate = window.cccisd && window.cccisd.boilerplate;

const SearchTest = () => {
    const [resources, setResources] = useState([]);
    const [searchId, setSearchId] = useState(0);
    const [thumbs, setThumbs] = useState([]);

    const getResources = async query => {
        if (query.length === 0) {
            return;
        }
        let response = await axios.get(Boilerplate.route('api.resources.resource.semantic_search'), {
            params: {
                query,
                tagId: 'searchtest',
            },
        });
        if (response.data.data) {
            setResources(response.data.data.results);
            setSearchId(response.data.data.searchId);
            setThumbs([]);
        } else {
            alert('Semantic search unavailable');
        }
    };

    const giveFeedback = async (resourceId, direction) => {
        await axios.post(Boilerplate.route('api.resources.resource.semantic_feedback'), {
            resource_id: resourceId,
            search_id: searchId,
            direction,
        });
        setThumbs({ ...thumbs, ['r' + resourceId]: direction });
    };

    return (
        <form
            className="queryForm"
            onSubmit={event => {
                event.preventDefault();
                const formData = new FormData(event.currentTarget);
                const query = formData.get('query');
                getResources(query);
            }}
        >
            <div style={{ margin: '40px' }}>
                Resource query: <input type="text" size="80" name="query" style={{ margin: '10px' }} />
                <button type="submit" className="btn btl-lg btn-primary">
                    Search
                </button>
                {resources.length > 0 && (
                    <Table
                        columns={[
                            {
                                name: 'resource',
                                label: 'Resource',
                                render: (value, row) => {
                                    return <div>{row.text ? row.text.split(';')[0] : ''}</div>;
                                },
                            },
                            {
                                name: 'score',
                                label: 'Score',
                                render: (value, row) => {
                                    return <div>{+value.toFixed(1)}</div>;
                                },
                            },
                            {
                                name: 'feedback',
                                label: 'Feedback?',
                                render: (value, row) => {
                                    let upIcon = '';
                                    if (thumbs['r' + row.id] === 1) {
                                        upIcon = (
                                            <span onClick={() => giveFeedback(row.id, 0)}>
                                                <IconUpFill />
                                            </span>
                                        );
                                    } else {
                                        upIcon = (
                                            <span onClick={() => giveFeedback(row.id, 1)}>
                                                <IconUp />
                                            </span>
                                        );
                                    }

                                    let downIcon = '';
                                    if (thumbs['r' + row.id] === -1) {
                                        downIcon = (
                                            <span onClick={() => giveFeedback(row.id, 0)}>
                                                <IconDownFill />
                                            </span>
                                        );
                                    } else {
                                        downIcon = (
                                            <span onClick={() => giveFeedback(row.id, -1)}>
                                                <IconDown />
                                            </span>
                                        );
                                    }
                                    return (
                                        <div>
                                            {upIcon}&nbsp;&nbsp;{downIcon}
                                        </div>
                                    );
                                },
                            },
                            {
                                name: 'text',
                                label: 'Title;Description;Tags;Search Terms;Body Text',
                            },
                        ]}
                        data={resources}
                        className="table"
                        showPerPageOptions={false}
                        hideShowingRowsSummary
                    />
                )}
            </div>
        </form>
    );
};

export default SearchTest;
